// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"23e0b5e2","261":"23e0b5e2","362":"23e0b5e2","505":"23e0b5e2","766":"23e0b5e2","823":"23e0b5e2","893":"23e0b5e2","965":"23e0b5e2"}[chunkId] + ".chunk.css";
};